
/* global aload */

var oTable;

$(document).ready(function () {

    if (typeof aload === 'function') {
        aload();

        $('img[data-fallback]').error(function () {
            var fallback = $(this).data('fallback');
            if (this.src !== fallback) {
                this.src = fallback;
            }
        });
    }

    $(document).on('click', 'div.erro, div.success', function () {
        $(this).remove();
    });

    /* Add a click handler to the rows - this could be used as a callback */
    $("table tbody").click(function (event) {

        if (oTable && oTable.fnSettings()) {
            $(oTable.fnSettings().aoData).each(function () {
                $(this.nTr).removeClass('row_selected');
            });
            $(event.target.parentNode).addClass('row_selected');
            selecionaLinha(event.target.parentNode);
        }
    });

    // #############################
    // ajax setup para mensagens de erro.
    // TODO: criar janela modal para mostrar as mensagens de forma mais amigável.
    // $.ajaxSetup({
    //     error: function (jqXHR, exception) {
    //         if (jqXHR.status === 0) {
    //             alert("Erro ao se conectar com o servidor.\nVerifique sua conexão de rede.");
    //         } else if (jqXHR.status === 404) {
    //             alert("[404] Página não encontrada.");
    //         } else if (jqXHR.status === 500) {
    //             alert("[500] Erro interno no servidor.");
    //         } else if (exception === 'timeout') {
    //             alert("Limite de tempo com conexão com o servidor foi excedido.");
    //         } else if (exception === 'abort') {
    //             alert("Conexão com o servidor cancelada.");
    //         } else {
    //             alert('Ocorreu um erro.\n' + jqXHR.responseText);
    //         }
    //     }
    // });

    function notifyByStatus(status, message) {
        switch (status) {
            case 400: // Bad Request
            case 404: // Not Found
            case 409: // Conflict
            case 412: // Precondition Failed
                notification.warning(message);
                break;
            default:
                notification.error(message);
                break;
        }
    }

    window.ajaxHelper = {
        fail: function (jqXHR, textStatus, errorThrown) {
            // 401 Unauthorized
            if (jqXHR.status === 401) {
                notification.warning('Operação não permitida. Sem autorização.');
                return;
            }

            // 412 - Precondition Failed
            if (jqXHR.status === 412 && typeof jqXHR.responseNative === 'string') {
                var json = $.parseJSON(jqXHR.responseNative);
                if (json.error) {
                    notification.warning(json.error);
                    return;
                }
            }

            if (jqXHR.status === 403) {
                var json = $.parseJSON(jqXHR.responseText);
                var mensagem = 'Permissão de acesso negada.';
                if (json.mensagens && json.mensagens.length > 0) {
                    mensagem += '<div class="mt-2"><details><summary>Permissão Necessária</summary><ul>';
                    for (var i = 0; i < json.mensagens.length; i++) {
                        mensagem += `<li>${json.mensagens[i]}</li>`;
                    }
                    mensagem += '</ul></details></div>';
                }
                return new Noty({
                    text: mensagem,
                    type: 'warning',
                    layout: 'topCenter',
                    closeWith: ['button']
                }).show();
                return;
            }

            if (jqXHR.responseJSON) {
                var message = textStatus + ': ' + errorThrown;
                if (jqXHR.responseJSON.error) {
                    message = jqXHR.responseJSON.error;
                } else if (jqXHR.responseJSON.errors
                        && jqXHR.responseJSON.errors.error) {
                    message = jqXHR.responseJSON.errors.error;
                } else if (jqXHR.responseJSON.warning) {
                    message = jqXHR.responseJSON.warning;
                }

                notifyByStatus(jqXHR.status, message);
            } else {
                notification.error(textStatus + ': ' + errorThrown);
            }
        }
    };
    window.utils = {
        prefixIfNotEmpty: function (value, prefix) {
            if (!value)
                return '';
            return prefix.toString() + value.toString();
        },
        /**
         * Creates a `tr` element with the correct td colspan based on $table.
         * @param {jQuery element} $table
         * @param {String} text
         * @returns {String}
         */
        emptyTable: function ($table, text) {
            var colspan = $table.find('thead tr th').length;
            text = text || 'Nenhum item encontrado.';
            return '<tr><td colspan="' + colspan
                    + '" class="text-center">'
                    + text + '</td></tr>';
        },
        /**
         * Creates a Bootstrap Alert.
         * @param {String} text Text to show. Default "Nenhum item encontrado."
         * @param {String} type One of alert-success, alert-info, alert-danger, alert-warning.
         * Default "alert-info"
         * @returns {window.$|$}
         */
        bsAlert: function (text, type) {
            return $('<div></div>', {
                text: text || 'Nenhum item encontrado.',
                class: 'alert ' + (type || 'alert-info'),
                role: 'alert'
            });
        },
        debounce: function (fn, delay) {
            var timeoutID = null;
            return function () {
                clearTimeout(timeoutID);
                var args = arguments;
                var that = this;
                timeoutID = setTimeout(function () {
                    fn.apply(that, args);
                }, delay);
            };
        }
    };
    window.select2 = {
        template: function (result) {
            return result.text
                    || (result.value + window.utils.prefixIfNotEmpty(result.cpf_cnpj_formatado, '-'));
        },
        templatePF: function (result) {
            return result.text + window.utils.prefixIfNotEmpty(result.cpf_formatado, '-');
        },
        processResults: function (data, params) {
            params.page = params.page || 1;
            return {
                results: data.lista || [],
                pagination: {
                    more: (params.page * 30) < data.total_count
                }
            };
        }
    };
});

/* Get the rows which are currently selected */
function fnGetSelected(oTableLocal) {
    var aReturn = new Array();
    var aTrs = oTableLocal.fnGetNodes();

    for (var i = 0; i < aTrs.length; i++) {
        if ($(aTrs[i]).hasClass('row_selected')) {
            aReturn.push(aTrs[i]);
        }
    }
    return aReturn;
}

var msgLinSelct = "Selecione um registro!";
function Trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}

function abrir(URL, width, height) {
    var left = 99;
    var top = 99;

    window.open(URL, 'janela', 'Width=' + width + ', Height=' + height + ', top=' + top + ', left=' + left + ', scrollbars=yes, status=no, toolbar=no, location=no, directories=no, menubar=no, resizable=no, fullscreen=no');
}

function mostreSumaDIV(mostre, suma) {
    document.getElementById(suma).style.display = 'none';
    document.getElementById(mostre).style.display = 'block';
}

function fecharJanela() {
    window.close();
}

function IsNumeric(sText) {
    var ValidChars = "0123456789.";
    var IsNumber = true;
    var Char;

    for (i = 0; i < sText.length && IsNumber == true; i++)
    {
        Char = sText.charAt(i);
        if (ValidChars.indexOf(Char) == -1)
        {
            IsNumber = false;
        }
    }
    return IsNumber;
}

var linhSelecionada = null;

function selecionaLinha(este) {
    linhSelecionada = este;
}

function mostrarMensagem(id, msg) {
    var aux = msg || "Erro desconhecido.";
    $(id).html(aux).show("blind", null, 500, esconderMensagem(id));
}

function esconderMensagem(id) {
    setTimeout(function () {
        $(id).fadeOut();
    }, 3000);
}
